import React, { Component } from 'react';
import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import renderTextField from '../../helpers/RenderTextFiledWithDiv';
import validationHelper from '../../helpers/ValidationHelper';
import autotecStyle from '../../components/Styles/style';

const validate = (values) => {
  const errors = validationHelper.validateRequired(['email'], values);
  return errors;
};

const linkStyle = {
  marginTop: '23%',
  marginLeft: '44%',
  display: 'block',
  color: '#002053',
  width: 55,
  height: 23,
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: 'normal',
  fontSize: 14,
  textAlign: 'center',
  textDecoration: 'none'
};

const fieldStyle = {
  width: '228px',
  marginTop: '20%'
};

class ForgotPassword extends Component {
  handleSave = (event) => {
    this.props.forgotPassword(event.email.trim());
  }

  render() {
    const { classes, handleSubmit } = this.props;

    return (
      <div>
        <Form onSubmit={handleSubmit(this.handleSave)}>
          <Field
            style={fieldStyle}
            name="email"
            component={renderTextField}
            label="Enter email to reset password"
            className={classes.textField}
            divClassName={classes.marginStyle}
            InputLabelProps={{
              style: {
                width: 192,
                height: 22,
                textAlign: 'left',
                fontStyle: 'normal',
                fontWeight: 'normal',
                lineHeight: 'normal',
                fontSize: '14px',
                color: 'rgba(0, 0, 0, 0.5)',
              }
            }}
            InputProps={{
              style: {
                width: 228,
              }
            }}
          />
          <Button
            style={{ width: 123, bottom: -95, padding: 'inherit' }}
            className={classes.buttonStyle}
            variant="raised"
            color="primary"
            type="submit"
            classes={{
              label: classes.buttonLabel, // class name, e.g. `classes-nesting-label-x`
            }}
          >Reset Password
          </Button>
          <a
            style={linkStyle}
            href='#'
            onClick={e => this.props.showLoginDialog(e)}
            variant="raised"
            color="primary"
          >Back
          </a>
        </Form>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  classes: PropTypes.shape().isRequired
};

export default withStyles(autotecStyle, { withTheme: true })(reduxForm({ form: 'ForgotPasswordUserForm', validate })(ForgotPassword));


// WEBPACK FOOTER //
// ./src/components/User/ForgotPassword.js